import { FIELD_UPDATE_SOURCE } from "@common/constants";

export function isAccrualAccountSuggestion(
    source: FIELD_UPDATE_SOURCE | null | undefined,
): boolean {
    return source === FIELD_UPDATE_SOURCE.ACCRUAL_DEFAULT_ACCOUNTS;
}
